const add_leading_zero = (num: string) => {
  if (num.length === 1) return `0${num}`;
  return num;
};

export { add_leading_zero };
